<template>
  <div class="select-household-container">
    <h3 v-if="isShowTitle" class="hint">
      {{ displayTitle }}
    </h3>
    <div class="select-household">
      <ul>
        <li @click="handleGetBarcode">
          <img
            src="@/assets/img/Barcode/barcode.png"
            :alt="$t('OrderFood.MobileBarcode')"
          >
          <h3>{{ $t('OrderFood.MobileBarcode') }}</h3>
        </li>
        <li @click="handleGetNfcCode">
          <img
            src="@/assets/img/NFC/nfc.png"
            :alt="$t('OrderFood.AccessCard')"
          >
          <h3>{{ $t('OrderFood.AccessCard') }}</h3>
        </li>
        <li @click="isHouseholdFrame = true">
          <img
            src="@/assets/img/Tablet/choice_tablet.png"
            :alt="$t('OrderFood.DirectlySelectHousehold')"
          >
          <h3>{{ $t('OrderFood.DirectlySelectHousehold') }}</h3>
        </li>
      </ul>
    </div>
    <ReadNFCBarcode ref="reader" />
    <HouseholdFrame
      :open.sync="isHouseholdFrame"
      @select-household="selectHousehold"
    />
  </div>
</template>

  <script>
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
import HouseholdFrame from '@/components/HouseholdFrame'
import { apiOrderFood } from '@/api/OrderFood'
import { convertKeysToCamelCase } from '@/js/utils/bff'
export default {
  name: 'PointTransaction',
  components: {
    ReadNFCBarcode,
    HouseholdFrame
  },
  props: {
    isShowTitle: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isHouseholdFrame: false,
      selectedHousehold: null
    }
  },
  computed: {
    displayTitle () {
      return this.title || this.$t('OrderFood.SelectDeductionMethod')
    }
  },
  methods: {
    /**
     * 處理取得手機條碼
     */
    handleGetBarcode () {
      this.$refs.reader.getCode(async (code) => {
        let isSuccess = false
        let errorMessage = ''
        try {
          const { status, data } = convertKeysToCamelCase((await apiOrderFood.getCommunityTabletsByPhone(code)).data)
          if (status === 1 && data.communityTablets.length > 0) {
            isSuccess = true
            this.handleEmitData(2, data.communityTablets, code)
          } else {
            errorMessage = this.$t('OrderFood.BarcodeVerifiedErrorMessage')
          }
        } catch (error) {
          errorMessage = error?.response?.data?.ErrorMessage?.Description || this.$t('OrderFood.BarcodeVerifiedErrorMessage')
        } finally {
          if (!isSuccess) {
            this.$alert(errorMessage, this.$t('General.AlertTitle'), {
              confirmButtonText: this.$t('General.OK'),
              callback: () => {
                this.$refs.reader.close()
              }
            })
          }
        }
      }, 'Barcode')
    },
    /**
     * 處理取得門禁卡、磁扣代碼
     */
    handleGetNfcCode () {
      this.$refs.reader.getCode(
        async (code) => {
          let isSuccess = false
          let errorMessage = ''
          try {
            const { status, data } = convertKeysToCamelCase((await apiOrderFood.getCommunityTabletsByCarrier(code)).data)
            if (status === 1 && data.communityTablets.length > 0) {
              isSuccess = true
              this.handleEmitData(3, data.communityTablets, code)
            } else {
              errorMessage = this.$t('OrderFood.NFCVerifiedErrorMessage')
            }
          } catch (error) {
            errorMessage = error?.response?.data?.ErrorMessage?.Description || this.$t('OrderFood.NFCVerifiedErrorMessage')
          } finally {
            if (!isSuccess) {
              this.$alert(errorMessage, this.$t('General.AlertTitle'), {
                confirmButtonText: this.$t('General.OK'),
                callback: () => {
                  this.$refs.reader.close()
                }
              })
            }
          }
        },
        {
          type: 'NFC',
          model: 'basic',
          title: '請將載具放在感應區',
          subtitle: '門禁卡、磁扣、悠遊卡、一卡通等'
        }
      )
    },
    // 處理直接選擇戶別
    selectHousehold (val) {
      this.handleEmitData(1, [val])
    },
    /**
     * 處理 emit 資料
     * @param {number} type 1: 直接選擇戶別, 2: 手機條碼, 3: 門禁卡、磁扣
     * @param {array} tablets 戶別資料陣列
     * @param {string} code 掃描/感應裝置取得的原始代碼（type 2/3 適用）
     */
    handleEmitData (type, tablets, code = '') {
      // 選擇戶別結單
      if (tablets.length) {
        this.$emit('getTypeData', type, tablets, code)
        this.$refs.reader.close()
        this.isHouseholdFrame = false
      }
    }
  }
}
  </script>

  <style lang="scss" scoped>
  .hint{
    padding-bottom: 20px;
  }
  .select-household-container {
    padding: 20px 0;
  }
  .select-household {
    img {
      width: 160px;
      height: 160px;
      object-fit: contain;
    }
    h3 {
      font-weight: bold;
      color: #5f5f5f;
      font-size: map-get($fontSize, xxx-large);
    }
    ul {
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 20px;
      li {
        text-align: center;
        width: 260px;
        height: 300px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 15px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        padding: 20px 30px;
        border: 1px solid #ddd;
        border-radius: 4px;
        color: #333;
      }
    }
  }
  </style>
